import EcommerceHomePage from "./pages/EcommerceHomePage";


function App() {
  return (
    <div className="App">
      <EcommerceHomePage/>
    </div>
  );
}

export default App;
